jQuery(function () {
    var myOffside = offside("#mobileMenu", {
        slidingElementsSelector: "body",
        buttonsSelector: ".menu-toggle, .offcanvas-close, .offcanvas-overlay",
        beforeOpen: function () {
            $(".offcanvas-overlay").fadeIn();
        },
        beforeClose: function () {
            $(".offcanvas-overlay").fadeOut();
        },
    });

    if ($(window).width() < 1024) {
        $("header").sticky({
            topSpacing: 0,
            zIndex: 99,
        });
        $(".product-category-wrap").sticky({
            topSpacing: 80,
            zIndex: 99,
        });
    } else {
        if (!$(".homepage").length > 0) {
            $("header").sticky({
                topSpacing: 0,
                zIndex: 99,
            });
        }
    }

    $(".back-to-top").on("click", function () {
        $("html, body").animate({ scrollTop: 0 }, 1000);
    });

    $(document).on("click", ".has-sub .toggle", function () {
        $(this).parent().next().slideToggle();
        $(this).toggleClass("fa-chevron-down fa-chevron-up");
    });

    $(".sidenav-toggle").on("click", function (e) {
        e.preventDefault();
        $(".product-category").toggleClass("show");
        $(".overlay").fadeIn();
        $("body").addClass("overflow-hidden");
    });

    $(".overlay").on("click", function (e) {
        e.preventDefault();
        $(".product-category").removeClass("show");
        $(".overlay").fadeOut();
        $("body").removeClass("overflow-hidden");
    });

    if ($(".project-detail-content-wrap").length > 0) {
        $(".project-detail-content-wrap").after($(".project-detail-form-wrap"));
        $(".project-detail-form-wrap").show();
    }

    $(".compare-wrap").twentytwenty({
        no_overlay: true,
    });

    $(".product-option").eq(0).find("a").trigger("click");

    $.fancybox.defaults.autoFocus = false;
    $.fancybox.defaults.backFocus = false;
    $(".fancybox-trigger").fancybox({
        thumbs: {
            autoStart: true,
            axis: "x",
        },
    });

    try {
        AOS.init({
            offset: 75,
            duration: 700,
            easing: "ease-out-back",
        });
    } catch (error) {}

    var wowHeight;
	if ($(window).width() >= 1366) {
		wowHeight = 650;
	}
	if ($(window).width() < 1366) {
		wowHeight = 800;
	}
	// $("#wowbook").wowBook({
	// 	width: 1240,
	// 	height: wowHeight,
	// 	centeredWhenClosed: true,
	// 	pdf: "./img/sample.pdf",
	// 	pageNumbers: false,
	// 	controls: {
	// 		zoomIn: "#zoomin",
	// 		zoomOut: "#zoomout",
	// 		next: "#next",
	// 		back: "#back",
	// 		first: "#first",
	// 		last: "#last"
	// 	},
	// 	scaleToFit: ".wowbook-wrapper"
	// });

    newsSlider();
    sideProductNav();
    productDetailSlide();
});

const menuMapping = new MappingListener({
    selector: ".menu-wrapper",
    mobileWrapper: ".offcanvas-wrap",
    mobileMethod: "appendTo",
    desktopWrapper: ".util-wrapper",
    desktopMethod: "insertBefore",
    breakpoint: 1024.98,
}).watch();

function sideProductNav() {
    $(".filter-toggle").on("click", function (e) {
        e.preventDefault();
        $(".product-filter-wrap").toggleClass("show");
        $(".overlay").fadeIn();
        $("body").addClass("overflow-hidden");
    });

    $(".overlay, .close-filter").on("click", function (e) {
        e.preventDefault();
        $(".product-filter-wrap").removeClass("show");
        $(".overlay").fadeOut();
        $("body").removeClass("overflow-hidden");
    });
}

function newsSlider() {
    $(".news-slider").each(function (index) {
        var $this = $(this);
        $this.addClass("news-slider-" + index);
        $this.find(".swiper-prev").addClass("news-slider-prev-" + index);
        $this.find(".swiper-next").addClass("news-slider-next-" + index);

        var newsSlider = new Swiper(
            ".news-slider-" + index + " .swiper-container",
            {
                slidesPerView: 3,
                spaceBetween: 30,
                navigation: {
                    prevEl: ".news-slider-prev-" + index,
                    nextEl: ".news-slider-next-" + index,
                },
                breakpoints: {
                    1024: {
                        slidesPerView: 2.25,
                        spaceBetween: 20,
                    },
                    768: {
                        slidesPerView: 1.5,
                        spaceBetween: 15,
                    },
                    576: {
                        slidesPerView: 1.15,
                        spaceBetween: 10,
                    },
                },
            }
        );
    });
}

const projectThumbnailsSlider = new Swiper(
    ".project-detail-thumbnails .swiper-container",
    {
        slidesPerView: 5,
        spaceBetween: 20,
        navigation: {
            nextEl: ".project-detail-images .swiper-next",
            prevEl: ".project-detail-images .swiper-prev",
        },
        breakpoints: {
            1024: {
                slidesPerView: 4.25,
            },
            768: {
                slidesPerView: 3.25,
            },
            576: {
                slidesPerView: 2.25,
            },
        },
    }
);

const projectImagesSlider = new Swiper(
    ".project-detail-images .swiper-container",
    {
        slidesPerView: 1,
        spaceBetween: 15,
        navigation: {
            nextEl: ".project-detail-images .swiper-next",
            prevEl: ".project-detail-images .swiper-prev",
        },
        thumbs: {
            swiper: projectThumbnailsSlider,
        },
    }
);

const projectSlider = new Swiper(".project-slider .swiper-container", {
    slidesPerView: 3,
    spaceBetween: 30,
    navigation: {
        nextEl: ".project-slider .swiper-next",
        prevEl: ".project-slider .swiper-prev",
    },
    breakpoints: {
        1024: {
            slidesPerView: 2.5,
            spaceBetween: 15,
        },
        768: {
            slidesPerView: 1.75,
            spaceBetween: 15,
        },
        576: {
            slidesPerView: 1.25,
            spaceBetween: 15,
        },
    },
});

function productDetailSlide() {
    var productDetailThumbnail = new Swiper(
        ".product-detail-thumbnail .swiper-container",
        {
            slidesPerView: 5,
            spaceBetween: 8,
            direction: "vertical",
            observer: true,
            observeParents: true,
            slideToClickedSlide: true,
            breakpoints: {
                1024: {
                    slidesPerView: 5,
                    spaceBetween: 10,
                    direction: "horizontal",
                    freeMode: true,
                },
                768: {
                    slidesPerView: 4.25,
                    spaceBetween: 5,
                    direction: "horizontal",
                },
                576: {
                    slidesPerView: 2.75,
                    spaceBetween: 5,
                    direction: "horizontal",
                },
            },
        }
    );

    var productDetailImages = new Swiper(
        ".product-detail-images .swiper-container",
        {
            observer: true,
            observeParents: true,
            thumbs: {
                swiper: productDetailThumbnail,
            },
            navigation: {
                prevEl: ".product-detail-thumbnail .swiper-prev",
                nextEl: ".product-detail-thumbnail .swiper-next",
            },
        }
    );
}

const historyYearSlider = new Swiper(".history-year-slider .swiper-container", {
    slidesPerView: 9,
    direction: "vertical",
    navigation: {
        prevEl: ".history-year-slider .swiper-prev",
        nextEl: ".history-year-slider .swiper-next",
    },
    observer: true,
    observeParents: true,
    breakpoints: {
        1280: {
            slidesPerView: 7,
        },
        1024: {
            slidesPerView: 7.75,
            direction: "horizontal",
            spaceBetween: 5,
        },
        768: {
            slidesPerView: 5.75,
            direction: "horizontal",
            spaceBetween: 5,
        },
        576: {
            slidesPerView: 3.75,
            direction: "horizontal",
            spaceBetween: 5,
        },
    },
});

const historyContentSlider = new Swiper(
    ".history-content-slider .swiper-container",
    {
        slidesPerView: 1,
        spaceBetween: 15,
        observer: true,
        observeParents: true,
        thumbs: {
            swiper: historyYearSlider,
        },
        navigation: {
            prevEl: ".history-year-slider .swiper-prev",
            nextEl: ".history-year-slider .swiper-next",
        },
    }
);

const awardSlider = new Swiper(".award-slider .swiper-container", {
    slidesPerView: 4,
    spaceBetween: 30,
    navigation: {
        prevEl: ".award-slider .swiper-prev",
        nextEl: ".award-slider .swiper-next",
    },
    breakpoints: {
        1024: {
            slidesPerView: 3.5,
        },
        768: {
            slidesPerView: 2.5,
        },
        576: {
            slidesPerView: 1.5,
        },
    },
});

const productHomeSlider = new Swiper(".product-home-slider .swiper-container", {
    slidesPerView: 4,
    spaceBetween: 30,
    breakpoints: {
        1024: {
            slidesPerView: 2.25,
            spaceBetween: 15,
        },
        768: {
            slidesPerView: 1.5,
            spaceBetween: 15,
        },
        576: {
            slidesPerView: 1.25,
            spaceBetween: 15,
        },
    },
    scrollbar: {
        el: ".product-home-slider .swiper-scrollbar",
    },
});

const projectHomeSlider = new Swiper(".project-home-slider .swiper-container", {
    slidesPerView: 3,
    spaceBetween: 20,
    initialSlide: 1,
    navigation: {
        prevEl: ".project-home-slider .swiper-prev",
        nextEl: ".project-home-slider .swiper-next",
    },
    breakpoints: {
        1024: {
            slidesPerView: 2.25,
            initialSlide: 0,
            spaceBetween: 15,
        },
        768: {
            slidesPerView: 1.5,
            initialSlide: 0,
            spaceBetween: 15,
        },
        576: {
            slidesPerView: 1.25,
            initialSlide: 0,
            spaceBetween: 15,
        },
    },
});

const partnerSlider = new Swiper(".partner-slider .swiper-container", {
    slidesPerView: 4,
    spaceBetween: 30,
    navigation: {
        prevEl: ".home-5 .swiper-prev",
        nextEl: ".home-5 .swiper-next",
    },
    breakpoints: {
        1024: {
            slidesPerView: 3.5,
        },
        768: {
            slidesPerView: 2.5,
        },
        576: {
            slidesPerView: 1.5,
        },
    },
});
